module.exports = __webpack_public_path__ + "static/media/tick.644e4574.svg";